/**
 * The bytes of every face the canvas was handed, by family.
 *
 * Skia keeps the faces it was given to itself and has no call that returns a glyph's
 * outline, so turning type into paths reads the same files a second time with fontkit.
 * Kept as they were registered — the built-in faces and each document face as it lands —
 * so the outlines come from exactly the bytes the letters were drawn with.
 */
const files = new Map<string, ArrayBuffer[]>();

export function rememberFace(family: string, bytes: ArrayBuffer): void {
  const list = files.get(family) ?? [];
  if (list.some((known) => known.byteLength === bytes.byteLength && sameBytes(known, bytes))) return;
  list.push(bytes);
  files.set(family, list);
}

export function faceFiles(family: string): readonly ArrayBuffer[] {
  return files.get(family) ?? [];
}

function sameBytes(a: ArrayBuffer, b: ArrayBuffer): boolean {
  const x = new Uint8Array(a);
  const y = new Uint8Array(b);
  // The header and table directory differ between any two faces worth telling apart.
  for (let i = 0; i < Math.min(512, x.length); i++) if (x[i] !== y[i]) return false;
  return true;
}
